import { Card, Icons, Typography, Upload, UploadFile } from '@pankod/refine-antd';
import { UploadChangeParam } from 'antd/lib/upload';
import styles from './ImportCsvDataCard.module.css';

interface ImportDataFromCSVCardProps {
  onFileUploadChange: (info: UploadChangeParam<UploadFile<any>>) => Promise<void>;
  onFileRemove: (file: UploadFile<any>) => void;
  hideTextWhenSidebarOpenOnMobile?: boolean;
}

const { Text } = Typography;

export const ImportCsvDataCard: React.FC<ImportDataFromCSVCardProps> = (props) => {
  return (
    <Card
      className={`${styles.card} ${
        props.hideTextWhenSidebarOpenOnMobile
          ? styles['card--hide-text-on-sidebar-open-mobile']
          : ''
      }`}
    >
      <Upload
        accept="text/csv"
        maxCount={1}
        beforeUpload={() => false}
        onChange={props.onFileUploadChange}
        onRemove={props.onFileRemove}
      >
        <div className={styles['card__upload-item']}>
          <span>
            <Icons.FileOutlined className={styles['card__icon']} />
          </span>
          <span>
            <Icons.UploadOutlined className={styles['card__icon']} />
          </span>
        </div>
        <Text className={styles['card__text']} style={{ cursor: 'pointer' }}>
          Upload .csv template for import
        </Text>
      </Upload>
    </Card>
  );
};
